import { FeaturesManage } from "../Components/index";

export default FeaturesManage;